import { useEffect, useState } from 'react';
import { api } from '../lib/api';

type Row = {
  _id: string;
  stripeCustomerId?: string;
  setupPaid: boolean;
  subscriptionStatus?: string | null;
  currentSeatCount: number;
  pricePerSeat: number;
  tenant?: { _id: string; slug: string; name: string } | null;
  updatedAt: string;
};

function dollars(cents: number) {
  return `$${(cents / 100).toFixed(2)}`;
}

export default function AdminBilling() {
  const [rows, setRows] = useState<Row[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api
      .get('/api/admin/billing')
      .then(({ data }) => setRows(data.accounts || []))
      .catch((e) => setError(e?.response?.data?.error?.message || 'Failed to load'));
  }, []);

  return (
    <main className="text-white">
      <section className="max-w-6xl mx-auto px-8 py-10">
        <h1 className="h-display text-3xl mb-6">Superadmin · Billing</h1>
        {error && <div className="text-red-400 text-sm mb-4">{error}</div>}
        <table className="w-full text-sm">
          <thead>
            <tr className="text-xs uppercase tracking-wider text-dgal-mist border-b border-dgal-navy-2">
              <th className="text-left py-2">Tenant</th>
              <th className="text-left">Setup</th>
              <th className="text-left">Subscription</th>
              <th className="text-left">Seats</th>
              <th className="text-left">MRR</th>
              <th className="text-left">Updated</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r._id} className="border-b border-dgal-navy-2/40">
                <td className="py-2">{r.tenant?.name || r.tenant?.slug || '—'}</td>
                <td>{r.setupPaid ? '✓' : '—'}</td>
                <td className="text-dg-text-2">{r.subscriptionStatus || '—'}</td>
                <td>{r.currentSeatCount}</td>
                <td>{dollars(r.currentSeatCount * r.pricePerSeat)}</td>
                <td className="text-dgal-mist">{new Date(r.updatedAt).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </main>
  );
}
